module.exports = __webpack_public_path__ + "static/media/diamond.67591d41.svg";